

<button
    *ngIf="styleType == 'primary'"
    [style]="extraStyle"
    [type]="submit ? 'submit' : 'button'"
    [disabled]="disabled || loading"
    class="btn-{{styleType}} {{extraClass}}"
    [ngStyle]="{'width': fullWidth ? '100%' : 'fit-content'}"
    (click)="onClick()"
    >
    <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
    <span *ngIf="!loading">{{text}}</span>
</button>

<button
    *ngIf="styleType == 'primary-flat'"
    [style]="extraStyle"
    [type]="submit ? 'submit' : 'button'"
    [disabled]="disabled || loading"
    class="btn-{{styleType}} {{extraClass}}"
    [ngStyle]="{'width': fullWidth ? '100%' : 'fit-content'}"
    (click)="onClick()"
    >
    <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
    <span *ngIf="!loading">{{text}}</span>
</button>


<button
    *ngIf="styleType == 'secondary'"  
    [style]="extraStyle"
    [type]="submit ? 'submit' : 'button'"
    [disabled]="disabled || loading"
    class="btn-{{styleType}} {{extraClass}}"
    [ngStyle]="{'width': fullWidth ? '100%' : 'fit-content'}"
    (click)="onClick()"
    >
    <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
    <span *ngIf="!loading">{{text}}</span>
</button>